export const getBudgetGraphColor = (
  amounts: number[],
  graphColors: { increase: string; decrease: string; consistent: string },
) => {
  const { consistent, decrease, increase } = graphColors;
  const firstAmount = amounts[0] ?? 0;
  const lastAmount = amounts.at(-1) ?? 0;
  return amounts.length <= 1 || firstAmount === lastAmount
    ? consistent
    : firstAmount >
        // FIXME: .at(-1) returns the union type with undefined. So, cannot use the right hand side of the comparison operator.
        lastAmount
      ? decrease
      : increase;
};
